import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import {
  EmptyState,
  GroupList,
} from "../../organisms/ArtifactConfigPanel/ArtifactConfigPanel.styles";

/**
 * Same scroll column the Sections panel uses. `flex: 1` + `min-height: 0` let
 * it take the space under the fixed header and scroll inside the panel
 * instead of stretching it.
 */
export const ScrollList = styled(GroupList)`
  flex: 1 1 auto;
  min-height: 0;
  box-sizing: border-box;
  padding: 0 ${spacing[1.5]} ${spacing[3]}; // 6px sides, 12px below the last row
`;

/** Sections panel's empty-copy recipe (Caption 4, low emphasis, 12px inset). */
export const StatusMessage = styled(EmptyState)`
  box-sizing: border-box;
  width: 100%;
`;

export const LoadingRow = styled(StatusMessage)`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  color: ${rawColors.text.mediumEmphasis};
`;

export const ErrorBlock = styled(StatusMessage)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing[2]};
`;

export const ErrorMessage = styled.p`
  margin: 0;
  color: ${rawColors.accent.red500};
  overflow-wrap: anywhere;
`;

export const RetryButton = styled.button`
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.interactive};

  &:hover {
    text-decoration: underline;
  }
`;
